import subchapter1 from './subchapter1'
import subchapter2 from './subchapter2'


export const chapter2sub1 = subchapter1;
export const chapter2sub2 = subchapter2;
// export default {
//   chapter2sub1: subchapter1,
//   chapter2sub2: subchapter2,
// }